import React from 'react';
import './WCCLogoIcon.css';

function WCCLogoIcon() {
  return <div className="wcc-logo-icon" />;
}

export default WCCLogoIcon;
